<!-- Rendered inside the lot-details vb-dialog, which owns the title + close. -->
<div class="parent-container">
    <div *ngIf="lotEditHistory.length > 0">
        <table>
            <tr>
                <th class="first-column">Date</th>
                <th class="second-column">Notes</th>
            </tr>
            <tr *ngFor="let note of lotEditHistory">
                <td class="first-column">
                    {{ note.editedOn | vbDateTime }}
                </td>
                <td
                    class="second-column"
                    style="vertical-align: middle"
                    [innerHTML]="sanitizeHtml(note.reason ?? '')"></td>
            </tr>
        </table>
    </div>
    <div *ngIf="lotEditHistory.length === 0">
        <p class="vb-empty-state">No edit history for this lot.</p>
    </div>
</div>
